import React, { useState, useEffect } from 'react';
import logo from '../../components/logo/srma-logo.webp';

export default function ComingSoon() {
  return (
    <div style={styles.container}>
        <img src={logo} width="10%" alt="Logo" style={{margin:'auto', display:'block'}} />
        <h1 style={styles.title}>🚀 Coming Soon</h1>
        <p style={styles.subtitle}>We're working hard to launch our new website.</p>
        <p style={styles.footer}>© 2025 SRMA</p>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '10%',
    backgroundColor: '#6b2020',
    color: '#f8fafc',
    height: '100vh',
  },
  title: {
    fontSize: '3rem',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '1.25rem',
    marginBottom: '30px',
  },
  timer: {
    fontSize: '1.5rem',
    marginBottom: '50px',
  },
  footer: {
    fontSize: '0.9rem',
    color: '#94a3b8',
  },
};